// extracted by mini-css-extract-plugin
export default {"inputFieldsWrapper":"AddMaterialForm_inputFieldsWrapper__0Y2h9","warningText":"AddMaterialForm_warningText__zxoSQ"};